const LeaderboardTable = ({ title, leaderboard }) => (
  <div className="mt-10 text-left">
    <h3 className="mv-heading mb-5 text-xl text-slate-100">{title}</h3>
    <div className="overflow-x-auto rounded-xl border border-slate-700/60 bg-cinema-950/40">
      <table className="w-full table-auto border-collapse text-left text-sm">
        <thead>
          <tr className="border-b border-slate-700/80 bg-cinema-850/80 text-xs uppercase tracking-wider text-cinema-accent">
            <th className="px-4 py-3 font-semibold">#</th>
            <th className="px-4 py-3 font-semibold">Player</th>
            <th className="px-4 py-3 font-semibold">Score</th>
            <th className="px-4 py-3 font-semibold">Date</th>
          </tr>
        </thead>
        <tbody className="text-slate-300">
          {leaderboard.length === 0 ? (
            <tr>
              <td
                colSpan={4}
                className="px-4 py-10 text-center text-slate-500"
              >
                No scores yet for this board.
              </td>
            </tr>
          ) : (
            leaderboard.map((entry, index) => (
              <tr
                key={entry._id || index}
                className="border-b border-slate-800/80 transition hover:bg-cinema-850/35"
              >
                <td className="px-4 py-3 font-display font-medium tabular-nums text-slate-400">
                  {index + 1}
                </td>
                <td className="max-w-[12rem] truncate px-4 py-3 font-medium text-slate-100 md:max-w-none">
                  {entry.username}
                </td>
                <td className="px-4 py-3 font-display tabular-nums text-cinema-accent">
                  {entry.score}
                </td>
                <td className="px-4 py-3 text-slate-500 tabular-nums">
                  {new Date(entry.timestamp).toLocaleDateString()}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  </div>
);

export default LeaderboardTable;
